import { useState } from 'react';

export default function RejectionNoteModal({ onReject, onCancel, count }) {
  const [note, setNote] = useState('');
  return (
    <div style={{
      padding: 16, background: '#fff', border: '1px solid #E2E8F0',
      borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.08)', marginTop: 8
    }}>
      <textarea
        value={note}
        onChange={e => setNote(e.target.value)}
        placeholder="Optional — add a reason for your records"
        rows={3}
        style={{
          width: '100%', border: '1px solid #E2E8F0', borderRadius: 12,
          padding: 12, fontSize: 11, fontFamily: 'Poppins, sans-serif',
          resize: 'vertical', outline: 'none', boxSizing: 'border-box'
        }}
        onFocus={e => e.target.style.borderColor = '#c9a84c'}
        onBlur={e => e.target.style.borderColor = '#E2E8F0'}
        onKeyDown={e => { if (e.key === 'Escape') onCancel(); }}
      />
      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        <button onClick={() => onReject(note || null)} style={{
          padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer',
          background: '#F97066', color: '#fff', fontSize: 11, fontWeight: 600, fontFamily: 'Poppins, sans-serif'
        }}>{count > 1 ? `Reject ${count} Assignments` : 'Reject'}</button>
        <button onClick={() => onReject(null)} style={{
          background: 'none', border: 'none', cursor: 'pointer',
          fontSize: 11, color: '#94A3B8', fontFamily: 'Poppins, sans-serif'
        }}>Skip</button>
      </div>
    </div>
  );
}
